// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"75":"22db691c","286":"c93bb7ad","318":"1d42e98e"}[chunkId] + ".chunk.css";
};